import * as actionTypes from "../actionTypes/Index";
import { promosCityLevelInitilState } from "./InitialState";
import { IActionType, IFetchPromoActionResponse } from "../../interfaces/Index";

const initialState = { ...promosCityLevelInitilState };

export const appendUpdatePromosCityLevel = (
  payload: IFetchPromoActionResponse,
  state: any
) => {
  if (payload.isPaginatedRes) {
    return [...state.promosCityLevel, ...payload.promosData];
  }
  return payload.promosData.slice();
};

export default function promosCityLevelReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.GET_PROMOS_CITY_LEVEL_INIT: {
      return Object.assign({}, state, {
        isFetchPromosLoading: true,
        isFetchPromosError: false,
        isPromoAdded: false,
        isPromoUpdated: false,
        error: null,
        isError: false,
      });
    }
    case actionTypes.GET_PROMOS_CITY_LEVEL_SUCCESS: {
      return Object.assign({}, state, {
        isFetchPromosLoading: false,
        promosCityLevel: appendUpdatePromosCityLevel(
          action.payload as any,
          state
        ),
        pagination: (action.payload! as any).pagination,
      });
    }
    case actionTypes.GET_PROMOS_CITY_LEVEL_FAIL: {
      return Object.assign({}, state, {
        isFetchPromosLoading: false,
        isFetchPromosError: true,
        error: action.error,
      });
    }
    case actionTypes.CREATE_PROMO_CITY_LEVEL_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isPromoAdded: false,
        error: null,
        promoId: null,
      });
    }
    case actionTypes.CREATE_PROMO_CITY_LEVEL_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isPromoAdded: true,
        promoId: action.payload,
      });
    }
    case actionTypes.CREATE_PROMO_CITY_LEVEL_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isPromoAdded: false,
        error: action.error,
        promoId: [],
      });
    }
    case actionTypes.GET_PROMO_CITY_LEVEL_DETAILS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isPromoAdded: false,
        isPromoDetailsFetched: false,
        promoDetails: {},
        isPromoUpdated: false,
      });
    }
    case actionTypes.GET_PROMO_CITY_LEVEL_DETAILS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isPromoDetailsFetched: true,
        promoDetails: action.payload,
      });
    }
    case actionTypes.GET_PROMO_CITY_LEVEL_DETAILS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.CLEAR_PROMO_CITY_LEVEL_DETAILS: {
      return Object.assign({}, state, {
        promoDetails: {},
        isPromoDetailsFetched: false,
        isPromoAdded: false,
        isPromoUpdated: false,
        isError: false,
        error: null,
      });
    }
    case actionTypes.UPDATE_PROMO_CITY_LEVEL_STATUS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isPromoUpdated: false,
        error: null,
        isPromoAdded: false,
      });
    }
    case actionTypes.UPDATE_PROMO_CITY_LEVEL_STATUS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isPromoUpdated: true,
      });
    }
    case actionTypes.UPDATE_PROMO_CITY_LEVEL_STATUS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isPromoUpdated: false,
        error: action.error,
      });
    }
    case actionTypes.UPDATE_PROMO_CITY_LEVEL_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isPromoUpdated: false,
        error: null,
        isPromoAdded: false,
      });
    }
    case actionTypes.UPDATE_PROMO_CITY_LEVEL_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isPromoUpdated: true,
      });
    }
    case actionTypes.UPDATE_PROMO_CITY_LEVEL_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isPromoUpdated: false,
        error: action.error,
      });
    }
    case actionTypes.GET_PROMO_CITY_LEVEL_BY_TYPE_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isPromoByTypeFetchError: false,
        error: null,
        isPromoByTypeFetched: false,
        promosByType: [],
      });
    }
    case actionTypes.GET_PROMO_CITY_LEVEL_BY_TYPE_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isPromoByTypeFetched: true,
        promosByType: (action.payload as any).slice(),
      });
    }
    case actionTypes.GET_PROMO_CITY_LEVEL_BY_TYPE_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isPromoByTypeFetchError: true,
        error: action.error,
        isPromoByTypeFetched: false,
      });
    }
    case actionTypes.GET_WAREHOUSE_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isWarehouseFetched: false,
        warehouseList: [],
      });
    }
    case actionTypes.GET_WAREHOUSE_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isWarehouseFetched: true,
        warehouseList: action.payload,
      });
    }
    case actionTypes.GET_WAREHOUSE_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isWarehouseFetched: false,
        error: action.error,
        warehouseList: [],
      });
    }
    case actionTypes.GET_UC_BY_CITY_ID_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isUcFetched: false,
        ucList: [{ id: "", name: "" }],
      });
    }
    case actionTypes.GET_UC_BY_CITY_ID_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isUcFetched: true,
        ucList: action.payload,
      });
    }
    case actionTypes.GET_UC_BY_CITY_ID_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isUcFetched: false,
        error: action.error,
      });
    }
    case actionTypes.UPLOAD_USER_LEVEL_PROMO_CSV_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        userLevelPromoCSV: null,
        isUserLevelPromoCSVAdded: false,
        isUserLevelPromoCsvLoading: true,
        isUserLevelPromoCsvUploaded: false,
        isUserLevelPromoCsvError: false,
        isPromoAdded: false,
      });
    }
    case actionTypes.UPLOAD_USER_LEVEL_PROMO_CSV_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        userLevelPromoCSV: action.payload,
        isUserLevelPromoCSVAdded: true,
        isUserLevelPromoCsvLoading: false,
        isUserLevelPromoCsvUploaded: true,
        isUserLevelPromoCsvError: false,
        isPromoAdded: true,
      });
    }
    case actionTypes.UPLOAD_USER_LEVEL_PROMO_CSV_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        userLevelPromoCSV: null,
        isUserLevelPromoCSVAdded: false,
        isUserLevelPromoCsvLoading: false,
        isUserLevelPromoCsvUploaded: true,
        isUserLevelPromoCsvError: true,
        isPromoAdded: false,
        userLevelPromoCsvError: action.error,
        error: action.error,
      });
    }
    case actionTypes.CREATE_PROMO_BULK_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isPromoAdded: false,
      });
    }
    case actionTypes.CREATE_PROMO_BULK_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        error: null,
        isPromoAdded: true,
      });
    }
    case actionTypes.CREATE_PROMO_BULK_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isPromoAdded: false,
        error: action.error,
      });
    }
    case actionTypes.DEACTIVATE_PROMO_BULK_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isPromoUpdated: false,
      });
    }
    case actionTypes.DEACTIVATE_PROMO_BULK_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        error: null,
        isPromoUpdated: true,
      });
    }
    case actionTypes.DEACTIVATE_PROMO_BULK_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isPromoUpdated: false,
        error: action.error,
      });
    }
    default:
      return state;
  }
}
